/** Keywords indicating PO Box, Rural Route, or General Delivery in address lines (legacy ESN parity). */
const POSTAL_KEYWORD_PATTERNS = [
  /\bpo\s*box\b/i,
  /\bp\.?\s*o\.?\s*box\b/i,
  /\bpobox\b/i,
  /\bpost\s*box\b/i,
  /\bbo[iî]te\s*postale\b/i,
  /\bgeneral\s+deliver(y|ies)\b/i,
  /\blivraison\s+g[eé]n[eé]rale\b/i,
  /\brural\s+route\b/i,
  /\broute\s+rurale\b/i,
  /\brr[\s#]*\d/i,
  /\bgd\b/i,
  /\bcp\b/i,
];

/**
 * Returns true when the street address or address line 3 indicates PO Box, Rural Route, or GD.
 */
export function detectPostalKeywordInAddress(streetAddress: string, addressLine3 = ''): boolean {
  const combined = `${streetAddress} ${addressLine3}`.trim();

  if (!combined) {
    return false;
  }

  return POSTAL_KEYWORD_PATTERNS.some((pattern) => pattern.test(combined));
}
